import React, { useState } from "react";

// Lightweight SVG world-ish abstraction with market markers and connection lines.
// Not a real map — an editorial "command centre" visualization.
export default function MarketMap({ markets = [], activeCode, onHover }) {
  const [hover, setHover] = useState(null);
  const home = markets.find((m) => m.code === "PK");

  return (
    <div className="relative w-full rounded-lg border border-[#D9E0E4] bg-navy overflow-hidden" data-testid="market-map">
      <svg viewBox="0 0 100 62" className="w-full h-full" role="img" aria-label="Abstract map of served trade markets">
        {/* grid */}
        <defs>
          <pattern id="grid" width="5" height="5" patternUnits="userSpaceOnUse">
            <path d="M5 0 L0 0 0 5" fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="0.2" />
          </pattern>
        </defs>
        <rect width="100" height="62" fill="url(#grid)" />

        {/* connection lines from home base */}
        {home && markets.filter((m) => m.code !== "PK").map((m) => (
          <line
            key={`line-${m.code}`}
            x1={home.x} y1={home.y} x2={m.x} y2={m.y}
            stroke={hover === m.code || activeCode === m.code ? "#D28A32" : "rgba(79,209,202,0.35)"}
            strokeWidth={hover === m.code || activeCode === m.code ? "0.4" : "0.25"}
            strokeDasharray="1 1.2"
          />
        ))}

        {/* markers */}
        {markets.map((m) => {
          const isHome = m.code === "PK";
          const isActive = hover === m.code || activeCode === m.code;
          return (
            <g
              key={m.code}
              onMouseEnter={() => { setHover(m.code); onHover && onHover(m.code); }}
              onMouseLeave={() => { setHover(null); onHover && onHover(null); }}
              className="cursor-pointer"
            >
              {isActive && <circle cx={m.x} cy={m.y} r="2.4" fill="none" stroke="#D28A32" strokeWidth="0.3" opacity="0.6" />}
              <circle cx={m.x} cy={m.y} r={isHome ? 1.5 : 1.1} fill={isHome ? "#D28A32" : isActive ? "#D28A32" : "#4FD1CA"} />
              <text x={m.x + 2} y={m.y + 0.8} fill={isActive ? "#fff" : "rgba(255,255,255,0.65)"} fontSize="2.1" fontFamily="Inter, sans-serif" fontWeight="600">
                {m.name}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}
